class messageCenterCtrl {
    constructor($rootScope, $scope, logger, httpRequest, $state) {
        $('body').addClass('leftnav-close')
        $rootScope.leftNavDisabled = true
        $scope.totalMessage = 0
        $scope.noReadMessage = 0
        $scope.queryParam = {
            orderMap: {},
            noticeTitle: '',
            startTime: '',
            endTime: '',
            messageType: '',
            instanceStatus: '',
            pageSize: 10,
            pageNum: 1,
        }

        // NOTE: 删除消息
        $scope.deleteMessage = () => {
            if (!$scope.selected.length) return
            const noticeIds = $scope.selected.map((item) => item.noticeId)
            deleteMessageMul({
                noticeIds
            })
        }

        // NOTE: 标记已读
        $scope.checkedMessage = () => {
            if (!$scope.selected.length) return
            const noticeIds = $scope.selected.map((item) => item.noticeId)
            setMessageReaded({
                noticeIds
            })
        }

        // NOTE: 全部标记已读
        $scope.checkedAllMessage = () => {
            setAllRead()
        }

        // NOTE: 刷新列表
        $scope.refreshMessage = () => {
            getMessageList(true)
        }

        // NOTE: 搜索
        $scope.searchMessage = () => {
            getMessageList()
        }

        // NOTE: 查看详情
        $scope.onNavToMessageDetail = (item) => {
            $state.go('message.detail', {
                noticeId: item.noticeId,
            })
        }

        // NOTE: 重置
        $scope.reset = () => {
            $scope.queryParam = Object.assign($scope.queryParam, {
                noticeTitle: '',
                startTime: '',
                endTime: '',
                messageType: '',
                instanceStatus: '',
            })
        }

        // NOTE: 已选择的消息
        $scope.selected = []

        // NOTE: 排序
        $scope.selectedHandle = () => {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            getMessageList()
        }

        // 表头排序
        $scope.orderMap = {
            sortKey: '',
            sortVal: '',
        }

        $scope.messageList = [{
            a: 1
        }]

        $scope.messageTypeList = [{
                key: 0,
                value: '系统消息',
            },
            {
                key: 1,
                value: '新用户消息',
            },
        ]

        $scope.messageStatusList = [{
                key: 0,
                value: '未读',
            },
            {
                key: 1,
                value: '已读',
            },
        ]

        $scope.total = 0

        // NOTE: page修改
        $scope.pageChanged = (pageNum) => {
            getMessageList()
        }

        const getMessageList = (fresh) => {
            const param = {
                ...$scope.queryParam
            }
            // NOTE: 查询消息列表
            if (param.messageType === '') {
                param.messageType = null
            }
            if (param.noticeTitle === '') {
                param.noticeTitle = null
            }
            if (param.instanceStatus === '') {
                param.instanceStatus = null
            }
            const data = {
                param,
                orderMap: param.orderMap,
                pageNum: param.pageNum,
                pageSize: param.pageSize,
            }

            if (data.param.startTime === '') data.param.startTime = null
            if (data.param.endTime === '') data.param.endTime = null

            httpRequest.fetchMessageList(data).then((res) => {
                if (res && res.data && res.data.success) {
                    $scope.messageList = res.data.value && res.data.value.list
                    $scope.total = res.data.value && res.data.value.total
                    if (fresh) {
                        logger.logSuccess('刷新成功')
                    }
                }
            })
        }

        const setAllRead = () => {
            httpRequest.setAllReaded().then((res) => {
                if (res && res.data && res.data.success) {
                    logger.logSuccess('设置成功')
                    getMessageList()
                    fetchMessageTotal()
                }
            })
        }

        const setMessageReaded = (noticeIds) => {
            httpRequest.setMessageReaded(noticeIds).then((res) => {
                if (res && res.data && res.data.success) {
                    logger.logSuccess('设置成功')
                    getMessageList()
                    fetchMessageTotal()
                }
            })
        }

        const fetchMessageTotal = () => {
            httpRequest.fetchMessageTotal().then((res) => {
                if (res && res.data && res.data.success) {
                    $scope.totalMessage = res.data.value && res.data.value.total
                    $scope.noReadMessage = res.data.value && res.data.value.noReadTotal
                }
            })
        }

        const deleteMessageMul = (noticeIds) => {
            httpRequest.deleteMessage(noticeIds).then((res) => {
                if (res && res.data && res.data.success) {
                    logger.logSuccess('删除成功')
                    getMessageList()
                    fetchMessageTotal()
                }
            })
        }

        getMessageList()
        fetchMessageTotal()
    }
}
messageCenterCtrl.$inject = [
    '$rootScope',
    '$scope',
    'logger',
    'httpRequest',
    '$state',
]
export default messageCenterCtrl


// WEBPACK FOOTER //
// ./src/app/main/message/messageCenterCtrl.js